import React, { useContext, useRef, useState } from 'react';
import { CloudUpload } from '@material-ui/icons';
import api from '../../../_core/api';
import icon from '../../../assets/cloud-computing.svg';
import { AuthContext } from '../../../_main/contexts/auth';
import { Container, Content, ImportArea, InputGroup } from './styles';
import { Button, Input } from '../../../_core/_components';

import { failure, handleErrors, success } from '../../../_core/services/toast';
import { FullScreenLoading } from '../../../_core/_components/fullscreen-loading';

type ErrorType = {
  response: {
    data: string;
  };
};

export const ImportacaoAjuizamentoManual: React.FC = () => {
  const { userName } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<File>();
  const refXls = useRef<HTMLInputElement | null>(null);

  const sendFormXls = async () => {
    setLoading(true);
    try {
      if (file) {
        const formdata = new FormData();
        formdata.append('file', file);

        await api.post(`/workflow/ajuizamento/ajuizamento-manual/upload`, formdata, {
          headers: {
            'BRM-User-Identifier': userName,
          },
        });
        success('Arquivo enviado.');
      }
    } catch (error) {
      if ((error as ErrorType).response) {
        failure((error as ErrorType).response.data);
        setLoading(false);
        return;
      }
      handleErrors(error);
    }
    setLoading(false);
  };

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const blob = e.target.files ? e.target.files[0] : undefined;
    if (blob === undefined) return;
    setFile(blob);
  };

  return (
    <Container>
      <FullScreenLoading isEnabled={loading} />
      <Content />
      <Content>
        <h1>Importar dados da planilha ajuizamento manual</h1>
        <ImportArea onClick={() => refXls.current?.click()}>
          <h2>Buscar arquivos</h2>
          <img src={icon} alt="" />
          <InputGroup onClick={e => e.stopPropagation()}>
            <Input
              state={[file?.name ?? 'Escolher arquivo', () => null]}
              disabled
              style={{ backgroundColor: 'white' }}
              startIcon={<CloudUpload />}
            />
            <input id="inputFileXls" type="file" hidden onChange={onFileChange} ref={refXls} />
          </InputGroup>
        </ImportArea>
        <Button text="Importar" onClick={sendFormXls} />
      </Content>
      <Content />
    </Container>
  );
};
